import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ListGroup from 'jbc-front/components/ListGroup';
import { useTranslation } from 'react-i18next';

import { REDUCER_NAME, fetchMonthMemos } from 'src/reducers/memos/memos';
import { getList, getIsLoading } from 'src/reducers/common/listReducer';
import { formatDateTh, formatDateThWithDash } from '../../../utils/Date';
import MemoListToday from './MemoListToday';
import MemoCalendar from './MemoCalendar';

const filterNoteByDate = (noteInMonth, date) => {
  const notes = Object.fromEntries(Object.entries(noteInMonth).filter(([key]) => key.includes(formatDateTh(date))));
  return Object.values(notes).pop();
};

const EmployeeMemo = ({ monthMemos, fetchMemos, memos, isLoading }) => {
  const { t } = useTranslation();
  const [noteInMonth, setNoteInMonth] = useState(monthMemos);
  const [noteOnDate, setNoteOnDate] = useState([]);
  const [markedDate, setMarkedate] = useState([]);

  const onSelectDateHandler = date => {
    // Fliter note with selected date
    const notes = filterNoteByDate(noteInMonth, date);
    setNoteOnDate(notes);
  };

  const onMonthChangeHandler = date => {
    setMarkedate([]);
    fetchMemos(formatDateThWithDash(date));
  };

  useEffect(
    () => {
      const dateList = Object.keys(noteInMonth);
      setMarkedate(dateList);

      if (Object.keys(memos).length > 0) {
        setNoteInMonth(memos);
      }
    },
    [noteInMonth, memos]
  );

  return (
    <div className="u-mt30">
      <ListGroup>
        <ListGroup.Title>{t('features.Dashbord.components.MemoListToday.employee_note')}</ListGroup.Title>
        <MemoCalendar
          onSelectDate={onSelectDateHandler}
          onMonthChange={onMonthChangeHandler}
          markedDate={markedDate}
          isLoading={isLoading}
        />
        <MemoListToday todayMemos={noteOnDate} />
      </ListGroup>
    </div>
  );
};

const mapStateToProps = state => ({
  memos: getList(REDUCER_NAME, state) || [],
  isLoading: getIsLoading(REDUCER_NAME, state)
});

const mapDispatchToProps = dispatch => ({
  fetchMemos: date => dispatch(fetchMonthMemos(date))
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeMemo);
